/// <amd-module name="TFS/Admin/Groups/Common/Util/GroupsTelemetryLogger" />
import { Feature } from "TFS/Admin/Common/Constants/TelemetryConstants";
import { AdminFeatureTelemetryLogger } from "TFS/Admin/Common/Util/Telemetry/AdminTelemetry";
import { ITfsPageService } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";

export enum GroupsComponent {
    None,
    GroupsPivot,
    GroupMembersPivot,
    MemberOfPivot,
    SettingsPivot,
    GroupsView,
    MemberAddPanel,
    MemberOfAddPanel,
    PermissionsPivot,
    UsersPivot,
    TeamsView,
    ServicePrincipalsPivot,
    MembersPivot
}

export class GroupsTelemetryLogger extends AdminFeatureTelemetryLogger {
    public constructor(context: IVssPageContext, component: GroupsComponent, action: string, feature: string = Feature.AdminDefault) {

        try {

            if (feature === Feature.AdminDefault) {

                const pageService = context.getService<ITfsPageService>("ITfsPageService");
                const pageData = pageService.getData();

                feature = (pageData && pageData.project) ? Feature.ProjectGroups : Feature.OrganizationGroups;
            }
        } catch (error) {
            // Capture telemetry in case of failure
            let telemetry: AdminFeatureTelemetryLogger = new AdminFeatureTelemetryLogger(
                context,
                Feature.AdminDefault,
                GroupsComponent[component],
                "Project scope lookup for telemetry"
            );
            telemetry.captureError(error);
        }

        super(context, feature, GroupsComponent[component], action);
    }
}
